/**
 * Reserved matches - matches that are assigned to the league, but are not yet added to any matchDay of the league.
 */
export const getReservedMatches = (matchDayMatchesIds = [], leagueMatches = []) => {
    if (!leagueMatches?.length) {
        return [];
    }
    if (!matchDayMatchesIds?.length) {
        return leagueMatches;
    }
    return leagueMatches?.filter(match => !matchDayMatchesIds?.find(id => match?.id === id))
}